import React from "react";
import DoctorDetailPage from "./DoctorDetailPage";

const DrDeepakBhuktarContent = () => {
  return (
    <DoctorDetailPage
      name="Dr. Deepak Bhuktar"
      specialization="Your Health & Happiness Cheerleader"
      experience="15 Years"
      degrees="MBBS, MD (Internal Medicine) from KEM Hospital Mumbai"
      quote="I believe I am becoming a pregnancy crafter who turns health into something joyful and practical."
      sections={[
        {
          title: "My Philosophy on Pregnancy Care",
          body: "I believe in celebrating pregnancy. My energy is focused on proactive health: good nutrition, safe physical activity, and a positive mindset. I am your cheerleader, motivating you to be an active participant in your health. We will set goals together and I will be there to encourage you every step of the way, ensuring both you and your baby are as strong and healthy as possible.",
        },
        {
          title: "Why I Chose Myprega",
          body: "The proactive, forward-thinking approach of Myprega is what drew me in. They don't just wait for problems to arise. The app, the educational content, and the regular check-ins are all designed to build positive momentum. This perfectly matches my philosophy of building a foundation of health and happiness from day one.",
        },
        {
          title: "Beyond the Clinic",
          body: "I am an avid runner and have completed several half-marathons. The discipline and resilience from running translate directly into my work. I love trying new cuisines and believe that healthy food can and should be delicious. My go-to book for inspiration is Atomic Habits by James Clear.",
        },
      ]}
      favorites={[
        { icon: "📖", label: "Favourite Book", value: "Atomic Habits by James Clear" },
        { icon: "🎵", label: "Favourite Singer", value: "Arijit Singh" },
        { icon: "🏃", label: "Favourite Pastime", value: "Long-distance running\nExploring new healthy cuisines" },
      ]}
    />
  );
};

export default DrDeepakBhuktarContent;
